var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('tooltip', {
    attrs: {
      "text": "<h1>Lorem ipsum dolor sit amet,</h1> consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id estconsectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est <br/><br/><br/><br/> laborum."
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "blue",
      "width": "1200px",
      "height": "700px",
      "color": "white",
      "padding": "20px"
    }
  }, [_c('h1', [_vm._v("Test")]), _c('p', [_vm._v("Test content inside tooltip")])])]), _c('v-container', [_c('partner-report-card-images', {
    ref: "images",
    staticClass: "ma-1",
    attrs: {
      "isCaptureEnvironment": true,
      "hideSelect": true,
      "dto": _vm.report
    },
    on: {
      "update:dto": function updateDto($event) {
        _vm.report = $event;
      }
    }
  }), _c('partner-report-card-images', {
    ref: "images",
    staticClass: "ma-1",
    attrs: {
      "isCaptureEnvironment": true,
      "hideSelect": true,
      "dto": _vm.report
    },
    on: {
      "update:dto": function updateDto($event) {
        _vm.report = $event;
      }
    }
  }), _c('br'), _c('br'), _c('v-divider'), _c('br'), _c('br'), _c('refs-selection-by-type', {
    attrs: {
      "partnerId": _vm.partnerId,
      "refType": _vm.refType,
      "showAsMenu": true,
      "selected": _vm.selected ? [{
        refId: _vm.selected.id,
        refType: 'ticket'
      }] : []
    },
    on: {
      "select": _vm.select
    }
  }), _vm._v(" selected: " + _vm._s(_vm.selected) + " ")], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }